const LocalStorageKeys = require('@/lib/Storage/LocalStorageKeys');
const OrderSearchCriteria = require('@/lib/Orders/Search/OrderSearchCriteria');
const { container } = require('@/container');

/**
 * @returns {OrderSearchCriteria}
 */
const createOrderSearchCriteria = () => {
    const searchCriteria = new OrderSearchCriteria();
    if (container.localStorageDataStore.find(LocalStorageKeys.ORDER_SEARCH_INCLUDE_CANCELLED)) {
        searchCriteria.includeCancelled = true;
    }

    if (container.localStorageDataStore.find(LocalStorageKeys.ORDER_SEARCH_INCLUDE_UNCONFIRMED)) {
        searchCriteria.includeUnconfirmed = true;
    }

    if (container.localStorageDataStore.find(LocalStorageKeys.ORDER_SEARCH_GROUP_BOOKINGS_ONLY)) {
        searchCriteria.groupBookingsOnly = true;
    }

    updateOrderSearchCriteria(searchCriteria);

    return searchCriteria;
};

/**
 * This updates the "includeCancelled" property of the search criteria based on the current state.
 *
 * @param {OrderSearchCriteria} searchCriteria
 */
const updateIncludeCancelled = (searchCriteria) => {
    if (searchCriteria.notes) {
        searchCriteria.setIncludeCancelled(true, 'notes');
        return;
    }

    if (searchCriteria.search) {
        const searchLooksLikeRefType = container.refValidator.stringLooksLikeSystemRef(searchCriteria.search);
        if (searchLooksLikeRefType) {
            console.log(`Including cancelled orders in search results because the search looks like a ${searchLooksLikeRefType} ref.`);
            searchCriteria.setIncludeCancelled(true, 'ref');
            return;
        }
    }

    if (container.localStorageDataStore.find(LocalStorageKeys.ORDER_SEARCH_INCLUDE_CANCELLED)) {
        searchCriteria.setIncludeCancelled(true, 'preference');
        return;
    }

    searchCriteria.setIncludeCancelled(false);
};

/**
 * This updates the "includeUnconfirmed" property of the search criteria based on the current state.
 *
 * Unlike cancelled orders there is no notes rule here. Searching notes forces cancelled orders in for reasons
 * specific to cancelled orders, and that does not apply to unconfirmed ones.
 *
 * @param {OrderSearchCriteria} searchCriteria
 */
const updateIncludeUnconfirmed = (searchCriteria) => {
    if (searchCriteria.search) {
        const searchLooksLikeRefType = container.refValidator.stringLooksLikeSystemRef(searchCriteria.search);
        if (searchLooksLikeRefType) {
            console.log(`Including unconfirmed orders in search results because the search looks like a ${searchLooksLikeRefType} ref.`);
            searchCriteria.setIncludeUnconfirmed(true, 'ref');
            return;
        }
    }

    if (container.localStorageDataStore.find(LocalStorageKeys.ORDER_SEARCH_INCLUDE_UNCONFIRMED)) {
        searchCriteria.setIncludeUnconfirmed(true, 'preference');
        return;
    }

    searchCriteria.setIncludeUnconfirmed(false);
};

/**
 * This updates the search options that we control on the user's behalf based on the current state.
 *
 * @param {OrderSearchCriteria} searchCriteria
 */
const updateOrderSearchCriteria = (searchCriteria) => {
    updateIncludeCancelled(searchCriteria);
    updateIncludeUnconfirmed(searchCriteria);
};

module.exports = {
    createOrderSearchCriteria,
    updateOrderSearchCriteria,
};
